export function toggleDropdown(event: Event): void {
  // Prevent the default action of the click event
  event.preventDefault();

  // Get the clicked element and ensure it's an HTML element
  const clickedElement = event.currentTarget as HTMLElement;

  // Find the parent <li> element
  const parentElement = clickedElement.closest(".nav-item") as HTMLElement | null;

  if (!parentElement) return;

  // Find the sibling <ul> with class 'dropdown-menu'
  const dropdownMenu = parentElement.querySelector(".dropdown-menu") as HTMLElement | null;

  if (!dropdownMenu) return;

  // Toggle the display of the dropdown menu
  if (dropdownMenu.style.display === "block") {
    dropdownMenu.style.display = "none"; // Hide if already visible
  } else {
    dropdownMenu.style.display = "block"; // Show if hidden
  }
}

export function toggleNavbar() {
  console.log("toggle");

  // Select the container-fluid element inside the navbar
  const containerFluid = document.querySelector(".navbar .container-fluid");

  if (containerFluid) {
    // Check if the element has the class 'mobile-nav-expanded'
    const isExpanded = containerFluid.classList.contains("mobile-nav-expanded");

    // Add the class if it's not present
    if (!isExpanded) {
      containerFluid.classList.add("mobile-nav-expanded");
    } else {
      // Remove the class with a 300ms delay
      setTimeout(() => {
        containerFluid.classList.remove("mobile-nav-expanded");
      }, 300);
    }
  }
}
